import React, { useEffect, useRef, useState } from "react";
import "./Selectable.scss";
export const PointPopupWrapper = (props) => {
    const labelRef = useRef();
    const { margins, scales, svgDimensions, point2show } = props;
    const [arrowClass, setArrowClass] = useState("");
    const computeLabelPosition = (xPointPosition, yPointPosition, containerRef, svgWidth, svgHeight) => {
        const heightMiddle = svgHeight / 2;
        const widthMiddle = svgWidth / 2;
        const delta10 = 10;
        const delta20 = 20;
        const positionedInLeftSide = xPointPosition + containerRef.current.offsetWidth > widthMiddle;
        const positionedInTopSide = yPointPosition + containerRef.current.offsetHeight > heightMiddle;
        const leftOffset = positionedInLeftSide
            ? xPointPosition - containerRef.current.offsetWidth + delta10
            : xPointPosition - delta20;
        const topOffset = positionedInTopSide
            ? yPointPosition - containerRef.current.offsetHeight - delta20
            : yPointPosition + delta10;
        containerRef.current.style.left = `${leftOffset}px`;
        containerRef.current.style.top = `${topOffset}px`;
        if (positionedInLeftSide) {
            setArrowClass(positionedInTopSide ? "bottom-right" : "top-right");
        }
        else {
            setArrowClass(positionedInTopSide ? "bottom-left" : "top-left");
        }
    };
    useEffect(() => {
        if (labelRef && labelRef.current && scales && point2show) {
            const xPos = scales.xScale(point2show.x);
            const yPos = point2show.hasDoubleAxis
                ? scales.y2Scale(point2show.y)
                : scales.yScale(point2show.y);
            const svgWidth = svgDimensions.width + margins.left;
            const svgHeight = svgDimensions.height + margins.bottom;
            computeLabelPosition(xPos, yPos, labelRef, svgWidth, svgHeight);
        }
    }, [scales, svgDimensions, labelRef, point2show]);
    if (point2show) {
        return (React.createElement("div", { className: `focus-selectable-point-label ${arrowClass}`, ref: labelRef, role: "pointPopup" },
            point2show.id && (React.createElement("span", null,
                React.createElement("b", null,
                    "ID: ",
                    point2show.id))),
            React.createElement("span", null,
                React.createElement("b", null,
                    "X: ",
                    point2show.x)),
            React.createElement("span", null,
                React.createElement("b", null,
                    "Y: ",
                    point2show.y))));
    }
    else {
        return null;
    }
};
//# sourceMappingURL=PointPopupWrapper.js.map